import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { OutskirtBuildingUpgrade } from "../outskirts/upgrade/OutskirtBuildingUpgrade";
var _TabUpgradeExternalBarn = function (_a) {
    var onInfoButtonClick = _a.onInfoButtonClick;
    return (React.createElement(OutskirtBuildingUpgrade, { type: IdOutskirtBuildings.ExternalBarn, onInfoButtonClick: onInfoButtonClick }));
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onInfoButtonClick: function () { return actionModalOpen(IdModal.ExternalBarnInfo); },
    }, dispatch);
};
export var TabUpgradeExternalBarn = connect(undefined, mapDispatch)(_TabUpgradeExternalBarn);



//////////////////
// WEBPACK FOOTER
// ./src/features/external-barn/TabUpgradeExternalBarn.tsx
// module id = 2633
// module chunks = 3